import { render, staticRenderFns } from "./DashboardFidChartsPDF.vue?vue&type=template&id=13b3e828&"
import script from "./DashboardFidChartsPDF.vue?vue&type=script&lang=js&"
export * from "./DashboardFidChartsPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports